export const CHAINS_PER_MILE = 80;
export const YARDS_PER_CHAIN = 22;
export const YARDS_PER_MILE = 1760;
export const METRES_PER_CHAIN = 20.1186;

export const chainsToYards = (chains) => Math.abs(chains) * YARDS_PER_CHAIN;

export const formatLineReference = (route_id, subposition, position) => {
    let yards = Math.floor((position - Math.floor(position / CHAINS_PER_MILE) * CHAINS_PER_MILE) * YARDS_PER_CHAIN);
    return `${route_id} ${Math.floor(position / CHAINS_PER_MILE)}m ${yards}y ${subposition}`;
};

const defaultLineReferenceFormatter = (pos) => `${pos.route} ${pos.mile}.${pos.chain} (${pos.subposition})`;

const formatLineReferenceLookup = {
    elr_mile_chain: (pos) => `${pos.route} ${pos.mile}.${pos.chain} (${pos.subposition})`,
    elr_mile_yards: (pos) => `${pos.route} ${pos.mile}m ${pos.yard}y (${pos.subposition})`,
    elr_meterage: (pos) => `${pos.route} ${pos.meterage()} m (${pos.subposition})`,
};

export const formatLineReference2 = (elrUnit, pos) => {
    const formatter = formatLineReferenceLookup[elrUnit];

    if (!formatter) {
        console.warn(`Unknown elr_unit: ${elrUnit}`);

        return defaultLineReferenceFormatter(pos);
    }

    return formatter(pos);
};
